import WeekAgenda from "../../components/planning/weekCalendrier";
import { LegendWeek } from "../../components/legend/legendWeek";

export function PlanningWeek() {
    // useEffect(() => {
    //     ScreenOrientation.lock({ orientation: 'landscape' });
    //     return () => {
    //         ScreenOrientation.unlock();
    //     };
    // }, []);
    return (
        <div>
            <WeekAgenda />
            <LegendWeek />
        </div>
    );
}